import { useState } from "react";
import "./testimonialTravala.scss";
import { FaStar } from "react-icons/fa";
import { Card, Carousel } from "react-bootstrap";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

const cardsDetails = [
  {
    name: "Alice Johnson",
    comment:
      "“The development team was fantastic! They delivered a high-quality software solution tailored to our needs, and the support has been exceptional throughout the project.”",
    starRating: 5,
    avatar: require('../../assets/images/avatar1.jpg')
  },
  {
    name: "Michael Smith",
    comment:
      "“Working with this software company was a pleasure. Their attention to detail and ability to turn complex requirements into an intuitive user experience was impressive.”",
    starRating: 4,
    avatar: require('../../assets/images/avatar2.png')
  },
  {
    name: "Sarah Williams",
    comment:
      "“Their agile approach and communication made the entire process smooth and transparent. The final product exceeded our expectations. Highly recommended!”",
    starRating: 5,
    avatar: require('../../assets/images/avatar3.png')
  },
  {
    name: "David Brown",
    comment:
      "“The team delivered a robust software solution on time and within budget. The after-sales support has been superb, and we couldn’t be happier with the results!”",
    starRating: 5,
    avatar: require('../../assets/images/avatar4.png')
  },
];

const TestimonialsTravala = () => {
  return (
    <div className="testimonial-travala-container">
      <div className="desktop-commnets">
        <ComentsForDesktop />
      </div>

      <div className="mobile-comments">
        <CommentsForMobile />
      </div>

      <div className="testimonial-text">
        <TestimonialText />
      </div>
    </div>
  );
};

const CommentsForMobile = () => {
  return (
    <Carousel
      interval={null}
      className="w-100"
      style={{ display: "flex", alignItems: "center" ,gap:"5px"}}
    >
      {cardsDetails.map((card, index) => (
        <Carousel.Item key={index}>
          <Card
            className="d-flex flex-row align-items-start p-4 m-2"
            style={{ borderRadius: "20px",height:"300px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={card.avatar} alt="Avatar" />
            </div>
            <Card.Body className="d-flex flex-column justify-content-start align-items-start">
              <Card.Title className="card-title">{card.name}</Card.Title>
              <div className="star-rating">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    className={
                      index < card.starRating ? "text-warning" : "text-muted"
                    }
                  />
                ))}
              </div>
              <Card.Text className="card-text">{card.comment}</Card.Text>
            </Card.Body>
          </Card>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

const ComentsForDesktop = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < cardsDetails.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          gap: "26px",
        }}
      >
        <div
          style={{
            background: currentIndex === 0 ? "black" : "white",
            width: "53px",
            height: "53px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid white",
            cursor: "pointer",
            borderRadius: "50%",
          }}
          onClick={handlePrevious}
        >
          <FaArrowUp color={currentIndex === 0 ? "white" : "black"} size={23} />
        </div>
        <div
          style={{
            background:
              currentIndex === cardsDetails.length - 1 ? "black" : "white",
            width: "53px",
            height: "53px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            borderRadius: "50%",
            border: "1px solid white",
          }}
          onClick={handleNext}
        >
          <FaArrowDown
            color={currentIndex === cardsDetails.length - 1 ? "white" : "black"}
            size={23}
          />
        </div>
      </div>

      <Card
        className="d-flex flex-column align-items-start p-3"
        style={{ borderRadius: "20px", width: "558px" }}
      >
        <div className="avatar-container">
          <img src={cardsDetails[currentIndex]?.avatar} alt="Avatar" className="rounded-circle avatar" />
        </div>
        <Card.Body
          className="d-flex flex-column justify-content-start align-items-start"
          style={{ marginTop: "-50px" }}
        >
          <Card.Title className="card-title">
            {cardsDetails[currentIndex]?.name}
          </Card.Title>
          <div className="star-rating">
            {[...Array(5)].map((_, index) => (
              <FaStar
                key={index}
                className={
                  index < cardsDetails[currentIndex]?.starRating
                    ? "text-warning"
                    : "text-muted"
                }
              />
            ))}
          </div>
          <Card.Text className="card-text">
            {cardsDetails[currentIndex]?.comment}
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

const TestimonialText = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "25px",
      }}
    >
      <p
        style={{
          color: "#FFF",
          fontFamily: "Inter, sans-serif",
          fontSize: "48px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "130%",
          letterSpacing: "-0.48px",
          textAlign: "left",
        }}
      >
       Customer Testimonials 
      </p>
      <p
        style={{
          color: "#FFF",
          fontFamily: "Inter, sans-serif",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "180%",
          textAlign: "left",
        }}
      >
        What our customers have to say about our service, check below!
      </p>
    </div>
  );
};

export default TestimonialsTravala;
